import React, { PureComponent } from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';

import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

import Pagination from 'components/Libs/Pagination';
import RegionModalAdd from './RegionModalAdd';
import Region from './Region';

const DWT_GROUPS = {
  mpp: {
    '3000_4500': 'DWT 3000-4500',
    '4501_6700': 'DWT 4501-6700',
    '6701_9000': 'DWT 6701-9000',
    '9001_12900': 'DWT 9001-12900',
    '12901_17800': 'DWT 12901-17800',
    '17801_24000': 'DWT 17801-24000',
  },
  bulk: {
    'minibulk': '< 10000 minibulker',
    'handysize': '10000 - 34999 handysize',
    'handymax': '35000 - 59999 handymax (supramax)',
    'panamax': '60000 -79999 panamax (new panamax)',
    'capesize': '80000 - 179999 Capesize',
    'verylarge': '180000 - 320000 VLCC (Very Large Crude Carriers)',
    'ultraverylarge': '> 320000 ULCC (Ultra Large Crude Carriers)'
  },
}
const ROWS = ['averagePortCostsUsdDay'];

export default class Disbursement extends PureComponent {

  state = {
    regions: [],
    searchFilter: '',
    isDialogOpened: false,
    unfoldView: localStorage.getItem('unfoldView') ? JSON.parse(localStorage.getItem('unfoldView')) : true
  }

  componentDidMount() {
    this.getRegions();
  }

  getRegions = async () => {
    let result = await api.disbursement.fetchList();

    if (result.status === 200) {
      this.setState({regions: result.data})
    }
  }

  removeRegion = async (id) => {
    let result = await api.disbursement.remove(id);

    if (result.status === 200) {
      showNotification('Region has been removed');
      return await this.getRegions();
    }

    let errors = getNormalErrors(result);
    showNotification(errors.error, 'error');
  }

  toggleState = (e, key = 'isDialogOpened') => {
    this.setState({
      [key]: !this.state[key],
    });
  }

  handleChange = (key = 'searchFilter', value) => {
    this.setState({[key]: value});
  }

  render() {
    let { regions = [], isDialogOpened, unfoldView, searchFilter } = this.state;
    let renderPagination = (
      <Pagination
        total={10}
        rowsPerPage={[10]}
        page={1}
        numberOfRows={10}
        updateRows={() => {}}
      />
    );

    return (
      <div className='container'>
        <div>
          <h4 className='text-center color-common'>{'Disbursements'}</h4>
          <div className='row'>
            <div className='col-md-3' style={{
              display: 'flex',
              alignItems: 'center'
            }}>
              <RaisedButton
                label={`Unfold: ${unfoldView}`}
                primary
                onClick={() => {
                  this.toggleState(null, 'unfoldView');
                  localStorage.setItem('unfoldView', !unfoldView);
                }}
                style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
                buttonStyle={{ lineHeight: '25px', height: '25px' }}
                labelStyle={{ fontSize: '11px' }}
              />
            </div>
            <div className='col-md-3 text-center'>
              {/*<div>
                <TextField
                  value={searchFilter}
                  hintText='Search'
                  onChange={(e, value) => this.handleChange('searchFilter', value)}
                  fullWidth
                />
              </div>*/}
            </div>
            <div className='col-md-6'>
              {/*renderPagination*/}
            </div>
          </div>
          <RegionModalAdd
            isDialogOpened={isDialogOpened}
            toggleDialog={this.toggleState}
            getRegions={this.getRegions}
            config={{dwtGroups: DWT_GROUPS}}
          />
          <Table selectable={false} className='time-charter-table'>
            <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
              <TableRow style={{borderBottom: '4px solid rgb(224, 224, 224)'}}>
                <TableHeaderColumn style={{width: '20%'}}>
                  Region
                </TableHeaderColumn>
                <TableHeaderColumn style={{width: '80%'}}>

                  <Table selectable={false}>
                    <TableHeader
                      displaySelectAll={false}
                      adjustForCheckbox={false}
                      style={{borderBottom: 'none'}}
                    >
                      <TableRow>
                        <TableHeaderColumn colSpan={2}>
                          MPP
                        </TableHeaderColumn>
                        <TableHeaderColumn colSpan={2}>
                          BULK
                        </TableHeaderColumn>
                      </TableRow>
                      <TableRow style={{borderBottom: 'none'}}>
                        <TableHeaderColumn >
                          {`DWT groups (mt)`}
                        </TableHeaderColumn>
                        <TableHeaderColumn >
                          {`Average Port Costs, usd/day`}
                        </TableHeaderColumn>
                        <TableHeaderColumn >
                          {`DWT groups (mt)`}
                        </TableHeaderColumn>
                        <TableHeaderColumn >
                          {`Average Port Costs, usd/day`}
                        </TableHeaderColumn>
                      </TableRow>
                    </TableHeader>
                  </Table>

                </TableHeaderColumn>
              </TableRow>
            </TableHeader>

            <TableBody displayRowCheckbox={false}>
              {
                regions.length ?
                  regions.map((r, i) => {
                    return (
                      <Region
                        data={r}
                        key={`time-charter-region-${r._id}`}
                        ts={Date.now()}
                        removeRegion={this.removeRegion}
                        getRegions={this.getRegions}
                        dwtGroups={DWT_GROUPS}
                        rows={ROWS}
                        unfold={unfoldView}
                      />
                    )
                  })
                : 'No data'
              }
            </TableBody>
          </Table>
          <div className='m-v-1'>
            <RaisedButton
              label='+ Add'
              primary
              onClick={this.toggleState}
              style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
              buttonStyle={{ lineHeight: '25px', height: '25px' }}
              labelStyle={{ fontSize: '11px' }}
            />
          </div>
          <div className='row'>
            <div className='col-md-6 col-md-offset-6'>
              {/*renderPagination*/}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/Disbursement/index.js